import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';

@Component({
    selector: 'price-calculator-dialog',
    templateUrl: 'price-calculator-dialog.component.html',
    inputs: ['showDialog'],
    outputs: ['onInjectArtistRevenue', 'onClose'],
    standalone: false
})
export class PriceCalculatorComponent {
    public showDialog: boolean = false;
    public onClose = new EventEmitter<void>();
    public onInjectArtistRevenue = new EventEmitter<number>();
    public showRecalculatingPriceInfo: boolean = false;
    @Output() showDialogChange = new EventEmitter<boolean>();

    public calcParams: ProductCalculationParam = { galleryCommission: 30, salesTax: 10, retailPrice: 0, artistRevenue: 0 };
    public galleryCommissionOptions: SelectItem[] = [
        { label: 'No Commission', value: 0 },
        { label: '10%', value: 10 },
        { label: '15%', value: 15 },
        { label: '20%', value: 20 },
        { label: '25%', value: 25 },
        { label: '30%', value: 30 },
        { label: '35%', value: 35 },
        { label: '40%', value: 40 },
        { label: '45%', value: 45 },
        { label: '50%', value: 50 },
        { label: '55%', value: 55 },
        { label: '60%', value: 60 },
        { label: '65%', value: 65 },
        { label: '70%', value: 70 },
    ];

    public taxOptions: SelectItem[] = [
        { label: 'No sales tax', value: 0 },
        { label: '5%', value: 5 },
        { label: '10%', value: 10 },
        { label: '15%', value: 15 },
        { label: '20%', value: 20 },
        { label: '25%', value: 25 },
        { label: '30%', value: 30 },
    ];

    constructor(private notificationsService: NotificationsService) { }

    public onGalleryCommissionChanged($event: DropdownChangeEvent) {
        this.showRecalculatingMessage();
        this.calculateRetailPriceFromArtistRevenue($event);
    }

    public onSalesTaxChanged($event: DropdownChangeEvent) {
        this.showRecalculatingMessage();
        this.calculateRetailPriceFromArtistRevenue($event);
    }

    private showRecalculatingMessage() {
        this.showRecalculatingPriceInfo = true;
        setTimeout(() => {
            this.showRecalculatingPriceInfo = false;
        }, 5000);
    }

    public calculateArtistRevenueFromRetailPrice($event: any) {
        //calculate the gallery commission on the user's provided retail price
        var galleryCommission = this.calculatePercent(this.calcParams.retailPrice, this.calcParams.galleryCommission);
        //now calculate the retail price after subtracting the gallery commission from it
        var retailPriceAfterCommission = this.calcParams.retailPrice - galleryCommission;
        //now calculate the total tax on price after gallery commission
        var totalTax = this.calculatePercent(retailPriceAfterCommission, this.calcParams.salesTax);
        //artist revenue after tax subtracting the tax
        this.calcParams.artistRevenue = Math.ceil(retailPriceAfterCommission - totalTax);
        console.log("After Retail Price Input: ", this.calcParams);

    }

    public calculateRetailPriceFromArtistRevenue($event: any) {
        var pricePlusGalleryCommission: number = this.calcParams.artistRevenue * (1 / (1 - this.calcParams.galleryCommission / 100));
        //now calculate the total tax that will be charged on the price
        var totalTax = this.calculatePercent(pricePlusGalleryCommission, this.calcParams.salesTax);
        //retail price after tax
        this.calcParams.retailPrice = Math.ceil(Number(pricePlusGalleryCommission) + Number(totalTax));
    }

    private calculatePercent(price: number, percentage: number) {
        return (price * percentage) / 100;
    }

    public injectArtistRevenue($event: any) {
        console.log("Artist Revenue Injected Params: ", this.calcParams);
        this.onInjectArtistRevenue.emit(this.calcParams.artistRevenue);
    }

    public onDialogClose($event: any) {
        this.showDialogChange.emit(false); // Also close parent dialog
        this.onClose.emit();
    }

    public preventNegativeValues(event: any, property: 'retailPrice' | 'artistRevenue'): void {
        let value = event.target.value;
        value = value.replace(/-/g, '');
        // Allow only valid decimal numbers (positive values with an optional decimal point)
        const regex = /^[0-9]*\.?[0-9]*$/;
    
        if (!regex.test(value)) {
            // If invalid, revert to previous valid value or set to empty string
            this.calcParams[property] = 0;
        } else {
            // Ensure value remains a valid positive decimal number
            this.calcParams[property] = value;
        }
        if (event.target.value < 0) {
          this.calcParams[property] = 0
        }
    }
}

export class ProductCalculationParam {
    galleryCommission!: number;
    salesTax!: number;
    retailPrice!: number;
    artistRevenue!: number;
}